import { Monster } from './Monster';
import { Earth } from '../earth/Earth';
import Phaser from 'phaser';
import { AudioManager, SoundEffect } from '../../systems/AudioManager';

export class BasicAlien extends Monster {

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.health = 50;
    this.maxHealth = 50;
    this.speed = 30;
    this.reward = 10;
    this.specialAbility = 'None';
    
    // Visual representation
    const circle = scene.add.circle(0, 0, 8, 0xff0000);
    circle.setName('monsterCircle');
    this.add(circle);
  }



  override activateAbility(): void {
    // Basic alien has no special ability
  }

  override takeDamage(amount: number): void {
    super.takeDamage(amount);
    
    // Visual feedback - change color temporarily
    const originalColor = 0xff0000;
    const flashColor = 0xffffff;
    
    // Find the circle visual and change its color
    const circle = this.getByName('monsterCircle');
    if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(flashColor);
      this.scene?.time.delayedCall(100, () => {
        circle.setFillStyle(originalColor);
      });
    } else if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(flashColor);
      this.scene?.time.delayedCall(100, () => {
        circle.fillStyle(originalColor);
      });
    }
  }
} 